// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface PhoneIconSignature {
  Element: SVGSVGElement;
}

export const PhoneIcon: TOC<PhoneIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M15 22H20C21.104 22 22 21.104 22 20V16C22 14.896 21.104 14 20 14H16C14.924 14 14.043 14.855 14.002 15.922C11.459 15.518 9.53 13.582 9.092 10.998C10.152 10.949 11 10.072 11 9V5C11 3.896 10.104 3 9 3H5C3.896 3 3 3.896 3 5V10C3 16.617 8.383 22 15 22ZM5 10V5H9V9H8C7.733 9 7.474 9.107 7.287 9.299C7.1 9.491 6.996 9.748 7 10.016C7.072 14.567 10.512 18 15 18C15.553 18 16 17.553 16 17V16H20L20.002 20H15C9.486 20 5 15.514 5 10Z"/>
</svg>
</template>;